import { useToast } from "@/shared/hooks/useToast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/shared/ui/toast";

export function Toaster() {
  const { toasts } = useToast();
  const skipErrorMessage = ["Неверный jwt токен"];
  return (
    <ToastProvider>
      {toasts
        .filter(function ({ description }) {
          return !skipErrorMessage.includes(String(description));
        })
        .map(function ({ id, title, description, action, ...props }) {
          return (
            <Toast key={id} {...props}>
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose />
            </Toast>
          );
        })}
      <ToastViewport />
    </ToastProvider>
  );
}
